var _rect, _path, _line, _line2, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigNumberPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 165,
    viewBox: "0 0 181 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 165,
    rx: 12,
    fill: "#CFD4DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2786 90.4775V58.5024L8.12513 60.1702L6.80242 52.9241L16.7515 49.9336H22.5024V90.4775H14.2786ZM29.5226 90.4775V83.749L41.3695 71.557C45.6251 67.1863 47.1779 65.001 47.1779 62.068C47.1779 59.02 45.1076 57.2948 42.3471 57.2948C39.5292 57.2948 37.5739 58.905 34.9859 62.068L29.5801 56.9497C33.0881 52.1764 37.1713 49.646 42.9797 49.646C50.3984 49.646 55.6317 54.0742 55.6317 61.3779V61.4929C55.6317 67.1288 53.0438 70.3493 47.0629 76.1578L40.3343 83.0013H55.6892V90.4775H29.5226ZM73.11 91.1676C67.2441 91.1676 62.9309 88.8673 59.8254 85.5318L64.8287 79.6658C66.899 81.8512 69.3719 83.5764 72.9375 83.5764C76.158 83.5764 78.5159 81.5636 78.5159 78.3431V78.2281C78.5159 74.7775 75.6404 72.7647 70.4646 72.7647H68.0492L67.0716 67.4739L75.928 57.6398H61.9532V50.2211H86.1646V56.8347L76.7331 66.7263C81.9089 67.7614 86.7397 70.9819 86.7397 77.9405V78.1131C86.7397 85.8193 81.2763 91.1676 73.11 91.1676Z",
    fill: "#373D43"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.59473,
    y1: 24.0266,
    x2: 177,
    y2: 24.0266,
    stroke: "#70777E",
    strokeWidth: 0.599054
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.59473,
    y1: 127.783,
    x2: 177,
    y2: 127.783,
    stroke: "#70777E",
    strokeWidth: 0.599054
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#70777E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 113,
    width: 130,
    height: 12,
    rx: 6,
    fill: "#70777E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 138,
    width: 46,
    height: 9,
    rx: 4.5,
    fill: "#70777E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigNumberPreview);
export default __webpack_public_path__ + "static/media/bigNumberPreview.636c37df3d35fc295fb42e80b23e9b4f.svg";
export { ForwardRef as ReactComponent };